<template>
  <div>
    <div id="interviews" data-cy="ameliaPage" v-cloak>
      <Alert />
      <Spinner />

      <nav class="navbar navbar-default navbar-fixed-top" style="z-index: 1050">
        <div class="container-fluid">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="/">
              <img
                :src="staticaddr + '/ivgcs/img/logo-original.png'"
                alt="InitialView"
                style="width: 218px; padding-top: 17px"
              />
            </a>
          </div>
          <div id="navbar" class="collapse navbar-collapse">
            <ul class="nav navbar-nav navbar-right waitToLoad">
              <li>
                <a
                  v-if="orgs.length == 0"
                  href="#list"
                  v-on:click="current_view = 'list'"
                  >{{ orgName }}</a
                >

                <a
                  v-if="orgs.length > 0"
                  href="#"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ orgName }}
                  <span class="caret" v-if="orgs.length > 0"></span>
                </a>
                <ul v-if="orgs.length > 0" class="dropdown-menu">
                  <li
                    class=""
                    v-for="org in orgs"
                    v-bind:key="org.org_code"
                    v-on:click="changeOrg(org)"
                  >
                    <a>{{ org.org_name }}</a>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#"
                  class="dropdown-toggle"
                  data-cy="orgType"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Filter by {{ orgTypeFilter.label }}
                  <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                  <li
                    class=""
                    v-for="orgType in orgTypes"
                    v-bind:key="orgType.label"
                    v-bind:data-cy="'orgType-' + orgType.type"
                    v-on:click="changeOrgTypeFilter(orgType)"
                  >
                    <a>{{ orgType.label }}</a>
                  </li>
                </ul>
              </li>
              <!-- <li data-toggle="tooltip" data-placement="bottom" title="Student List">
		                <a href="#list">
		                    <span class='glyphicon glyphicon-list'></span>
		                    <span class='sr-only'>Student List</span>
		                </a>
		            </li> -->
              <li
                v-show="
                  org_has_recruited &&
                  (orgTypeFilter.type == 'org_facing_college' ||
                    orgTypeFilter.type == 'org_facing_transfer' ||
                    orgTypeFilter.type == 'org_facing_otis' ||
                    orgTypeFilter.type == 'org_facing_otis_summer' ||
                    orgTypeFilter.type == 'org_facing_otis_transfer' ||
                    orgTypeFilter.type == 'org_facing_otis_hs' ||
                    orgTypeFilter.type == 'org_facing_otis_flyin')
                "
                data-toggle="tooltip"
                data-placement="bottom"
                title="Recruited Students"
              >
                <a v-on:click="filterListByRecruited()">
                  <img
                    v-show="recruitedFilter"
                    width="16px"
                    :src="staticaddr + '/s/img/_shared/icon-iv-referred.png'"
                  />
                  <img
                    v-show="!recruitedFilter"
                    width="16px"
                    :src="
                      staticaddr + '/s/img/_shared/icon-iv-referred-grey.png'
                    "
                  />
                  <span class="sr-only">Recruited</span>
                </a>
              </li>
              <li
                v-show="
                  orgTypeFilter.type == 'org_facing_college' ||
                  orgTypeFilter.type == 'org_facing_transfer' ||
                  orgTypeFilter.type == 'org_facing_otis'
                "
                data-toggle="tooltip"
                data-placement="bottom"
                title="Stars!"
              >
                <a v-on:click="filterListByStars()">
                  <span
                    class="glyphicon glyphicon-star"
                    v-bind:style="{ color: starFilter === 1 ? '#e96724' : '' }"
                  ></span>
                  <span class="sr-only">Stars</span>
                </a>
              </li>
              <li
                data-toggle="tooltip"
                data-placement="bottom"
                title="Settings"
              >
                <a data-cy="settings" href="#settings">
                  <span class="glyphicon glyphicon-cog"></span>
                  <span class="sr-only">Settings</span>
                </a>
              </li>
              <li
                data-toggle="tooltip"
                data-placement="bottom"
                title="Fee Waivers"
                v-if="fee_waivers.length > 0"
              >
                <a href="#feewaiver">
                  <img
                    width="16px"
                    :src="staticaddr + '/s/img/_shared/icon-fee-waiv.svg'"
                  />
                  <span class="sr-only">Fee Waivers</span>
                </a>
              </li>
              <li class="dropdown" v-show="underGrad">
                <a
                  href="#"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >Resources<span class="caret"></span
                ></a>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      target="_blank"
                      :href="
                        orgTypeFilter.type != 'org_facing_boarding'
                          ? '/ivgcs/docs/cycleprepchecklist2026.pdf'
                          : '/ivgcs/docs/cycleprepchecklist2025boardingschools.pdf'
                      "
                    >
                      Cycle Prep Checklist and Reader Training Resource
                    </a>
                  </li>
                </ul>
              </li>
              <!--Removed PUR panel for Boarding schools-->
              <!-- <li class="dropdown" v-show="!underGrad">
                <a
                  href="#"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >Resources<span class="caret"></span
                ></a>
                <ul class="dropdown-menu">
                  
                  <li v-show="isNotPowerUser">
                    <hr style="margin: 5px" />
                    <div style="padding: 5px 20px; font-style: italic">
                      NEW! Become an <b>Amelia Power User</b> to gain access to
                      the additional valuable resources below! Reach out to us
                      at contact@initialview.com to learn more!
                    </div>
                  </li>
                </ul>
              </li> -->
              <li data-toggle="tooltip" data-placement="bottom" title="Logout">
                <a href="#logout" v-on:click.prevent="user_logout()">Log Out</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <!-- end of regular navbar -->

      <div
        style="padding-top: 51px"
        v-show="current_view == 'list'"
      >
        <nav class="navbar navbar-inverse navbar-fixed-top" style="top: 69px">
          <div class="container" style="width: 100%">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#list-navbar"
                aria-expanded="false"
                aria-controls="navbar"
              >
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div id="list-navbar" class="collapse navbar-collapse">
              <form
                class="navbar-form navbar-left"
                style="color: #eee; margin-left: -15px"
              >
                <!-- for some reason navbar-right has -15px margin but navbar-left doesn't, even though it should for consistentcy -->
                <div class="form-group">
                  Order by
                  <select
                    data-cy="sortBy"
                    class="form-control"
                    v-model="orderByColumn"
                    style="margin-left: 10px"
                  >
                    <option value="dateReceived">Date Received</option>
                    <option value="lastName">Last Name</option>
                    <option value="firstName">First Name</option>
                    <option value="dateOfBirth">Date of Birth</option>
                    <option value="email">Email</option>
                    <option value="reviewScoreAve">Score</option>
                  </select>
                </div>
                <div
                  class="form-group"
                  style="margin-left: 10px; margin-right: 10px"
                >
                  <div class="btn-group-vertical">
                    <div
                      data-cy="sortBy-up"
                      class="btn btn-default btn-xs"
                      style="font-size: 8px"
                      v-on:click="sortOrder = 1"
                      v-bind:class="{ active: sortOrder == 1 }"
                    >
                      <i class="glyphicon glyphicon-menu-up"></i>
                    </div>
                    <div
                      data-cy="sortBy-down"
                      class="btn btn-default btn-xs"
                      style="font-size: 8px"
                      v-on:click="sortOrder = -1"
                      v-bind:class="{ active: sortOrder == -1 }"
                    >
                      <i class="glyphicon glyphicon-menu-down"></i>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  then by
                  <select
                    data-cy="thenSortBy"
                    class="form-control"
                    v-model="orderByColumn2"
                    style="margin-left: 10px"
                    v-on:change="sortOrder2 = 1"
                  >
                    <option value="">----</option>
                    <option value="dateReceived">Date Received</option>
                    <option value="lastName">Last Name</option>
                    <option value="firstName">First Name</option>
                    <option value="dateOfBirth">Date of Birth</option>
                    <option value="email">Email</option>
                    <option value="reviewScoreAve">Score</option>
                  </select>
                </div>
                <div
                  class="form-group"
                  style="margin-left: 10px; margin-right: 10px"
                >
                  <div class="btn-group-vertical">
                    <div
                      data-cy="thenSortBy-up"
                      class="btn btn-default btn-xs"
                      style="font-size: 8px"
                      v-on:click="sortOrder2 = 1"
                      v-bind:class="{ active: sortOrder2 == 1 }"
                    >
                      <i class="glyphicon glyphicon-menu-up"></i>
                    </div>
                    <div
                      data-cy="thenSortBy-down"
                      class="btn btn-default btn-xs"
                      style="font-size: 8px"
                      v-on:click="sortOrder2 = -1"
                      v-bind:class="{ active: sortOrder2 == -1 }"
                    >
                      <i class="glyphicon glyphicon-menu-down"></i>
                    </div>
                  </div>
                </div>
              </form>
              <ul
                class="nav navbar-nav navbar-nav-thin"
                v-show="selectedInterviews > 0"
              >
                <li class="nav-badge">
                  <span
                    style="background-color: #79a9ad; color: white"
                    class="badge"
                    >{{ selectedInterviews }}</span
                  >
                </li>
                <li class="dropdown">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Mark As <span class="caret"></span
                  ></a>
                  <ul class="dropdown-menu">
                    <li
                      v-for="option in reviewStatusOptions"
                      v-bind:key="option.value"
                    >
                      <a
                        v-on:click.prevent="
                          whereCheckboxTrueAction('mark', option.value)
                        "
                        >{{ option.text }}</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    >Export <span class="caret"></span
                  ></a>
                  <ul class="dropdown-menu">
                    <li class="">
                      <a
                        v-on:click.prevent="
                          whereCheckboxTrueAction('export', 1)
                        "
                        >Excel</a
                      >
                    </li>
                    <li class="">
                      <a
                        v-on:click.prevent="
                          whereCheckboxTrueAction('export', 2)
                        "
                        >Writing Samples</a
                      >
                    </li>
                    <li class="">
                      <a
                        v-on:click.prevent="
                          whereCheckboxTrueAction('export', 3)
                        "
                        >PDF</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
              <form class="nav navbar-form navbar-right">
                <div class="form-group">
                  <button
                    v-if="
                      orgTypeFilter &&
                      orgTypeFilter.type == 'org_facing_college' &&
                      interviews.length > 0
                    "
                    class="btn btn-default"
                    style="margin-right: 10px"
                    data-toggle="modal"
                    data-target="#starreport"
                  >
                    Star Report
                  </button>
                  <button
                    v-if="
                      orgTypeFilter &&
                      orgTypeFilter.type == 'org_facing_college' &&
                      interviews.length > 0
                    "
                    class="btn btn-default"
                    style="margin-right: 10px"
                    @click.prevent="$refs.generateReportFromFile.click()"
                  >
                    Star Finder
                  </button>
                  <button
                    data-cy="exportAll"
                    class="btn btn-default"
                    style="margin-right: 10px"
                    @click.prevent="exportAllCsv()"
                  >
                    Export<span class="hidden-sm">
                      All {{ orgTypeFilter.label }}</span
                    >
                  </button>
                  <button
                    data-cy="refresh"
                    class="btn btn-default"
                    style="margin-right: 10px"
                    @click.prevent="fetchInterviewsWithFilters()"
                  >
                    Refresh
                  </button>
                  <input
                    type="file"
                    ref="generateReportFromFile"
                    @change="uploadGenerateReportFromFile"
                    style="display: none"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  />
                </div>
                <div style="color: #f9f9f9" class="form-group">
                  <span v-show="interviews.length == sortedInterviews.length">
                    {{ interviews.length }} Records
                  </span>
                  <span v-show="interviews.length != sortedInterviews.length">
                    Filtered {{ sortedInterviews.length }} of
                    {{ interviews.length }}
                  </span>
                </div>
              </form>
            </div>
          </div>
        </nav>

        <div style="width: 100%; min-width: 1394px">
          <table class="table table-bordered table-striped" id="listhead">
            <thead>
              <tr>
                <th
                  data-ref="select"
                  style="max-width: 55px; min-width: 55px"
                  data-toggle="tooltip"
                  data-container="body"
                  data-placement="bottom"
                  title="Click a row to select or unselect it. Hold down SHIFT and click a row to select or unselect the range."
                  class="text-center"
                >
                  <div>Select</div>
                  <small
                    v-on:click="clearAll(filteredInterviews)"
                    style="cursor: pointer"
                    ><u>Clear</u></small
                  >
                </th>
                <th
                  data-cy="columnHeader-dateReceived"
                  data-ref="dateReceived"
                  style="max-width: 130px; min-width: 130px"
                  v-bind:class="{
                    'sorted-column': orderByColumn == 'dateReceived',
                  }"
                >
                  <div class="text-center">
                    Date Received
                    <span
                      v-if="orderByColumn == 'dateReceived'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'dateReceived'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <input
                    data-cy="filterInput-dateReceived"
                    type="text"
                    class="form-control"
                    v-model="filterObject.dateReceived"
                  />
                </th>
                <th
                  data-cy="columnHeader-lastName"
                  data-ref="lastName"
                  style="min-width: 110px"
                  v-bind:class="{
                    'sorted-column': orderByColumn == 'lastName',
                  }"
                >
                  <div class="text-center">
                    Last Name
                    <span
                      v-if="orderByColumn == 'lastName'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'lastName'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <input
                    data-cy="filterInput-lastName"
                    type="text"
                    class="form-control"
                    v-model="filterObject.lastName"
                  />
                </th>
                <th
                  data-cy="columnHeader-firstName"
                  data-ref="firstName"
                  style="min-width: 110px"
                  v-bind:class="{
                    'sorted-column': orderByColumn == 'firstName',
                  }"
                >
                  <div class="text-center">
                    First Name
                    <span
                      v-if="orderByColumn == 'firstName'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'firstName'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <input
                    data-cy="filterInput-firstName"
                    type="text"
                    class="form-control"
                    v-model="filterObject.firstName"
                  />
                </th>
                <th
                  data-cy="columnHeader-dateOfBirth"
                  data-ref="dateOfBirth"
                  style="max-width: 130px; min-width: 130px"
                  v-bind:class="{
                    'sorted-column': orderByColumn == 'dateOfBirth',
                  }"
                >
                  <div class="text-center">
                    Date of Birth
                    <span
                      v-if="orderByColumn == 'dateOfBirth'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'dateOfBirth'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <input
                    data-cy="filterInput-dateOfBirth"
                    type="text"
                    class="form-control"
                    v-model="filterObject.dateOfBirth"
                  />
                </th>
                <th
                  data-ref="appid"
                  style="min-width: 120px"
                  v-bind:class="{ 'sorted-column': orderByColumn == 'appid' }"
                  v-show="
                    orgTypeFilter.type == 'org_facing_college' ||
                    orgTypeFilter.type == 'org_facing_transfer' ||
                    orgTypeFilter.type == 'org_facing_otis' ||
                    orgTypeFilter.type == 'org_facing_viva'
                  "
                >
                  <div class="text-center">
                    Application ID
                    <span
                      v-if="orderByColumn == 'appid'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'appid'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filterObject.appId"
                  />
                </th>
                <th
                  data-cy="columnHeader-email"
                  data-ref="email"
                  style="min-width: 200px"
                  v-bind:class="{ 'sorted-column': orderByColumn == 'email' }"
                >
                  <div class="text-center">
                    Email
                    <span
                      v-if="orderByColumn == 'email'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'email'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <input
                    data-cy="filterInput-email"
                    type="text"
                    class="form-control"
                    v-model="filterObject.email"
                  />
                </th>
                <th
                  data-ref="org_facing_star"
                  style="max-width: 57px; min-width: 57px"
                  v-show="
                    orgTypeFilter.type == 'org_facing_college' ||
                    orgTypeFilter.type == 'org_facing_transfer' ||
                    orgTypeFilter.type == 'org_facing_otis'
                  "
                  class="text-center"
                >
                  <div>Star?</div>
                  <button
                    class="btn btn-default"
                    v-on:click="filterListByStars()"
                  >
                    <span
                      class="glyphicon glyphicon-star"
                      v-bind:style="{
                        color: starFilter === 1 ? '#e96724' : '#777',
                      }"
                    ></span>
                  </button>
                </th>
                <th
                  data-ref="org_facing_rose"
                  style="max-width: 57px; min-width: 57px"
                  v-show="
                    orgTypeFilter.type == 'org_facing_college' ||
                    orgTypeFilter.type == 'org_facing_transfer' ||
                    orgTypeFilter.type == 'org_facing_otis'
                  "
                  class="text-center"
                >
                  <div>Rose?</div>
                  <button
                    class="btn btn-default"
                    v-on:click="filterListByRoses()"
                  >
                    <img
                      v-if="roseFilter === 1"
                      :src="
                        staticaddr +
                        '/ivgcs/img/lone-yellow-rose-transparent.png'
                      "
                      style="height: 20px"
                    />
                    <img
                      v-else
                      :src="
                        staticaddr + '/ivgcs/img/lone-gray-rose-transparent.png'
                      "
                      style="height: 20px"
                    />
                    <!-- <span class='glyphicon glyphicon-tree-deciduous' v-bind:style="{color: roseFilter === 1 ? '#e96724' : '#777'}"></span> -->
                  </button>
                </th>
                <th
                  data-ref="org_facing_reply"
                  style="max-width: 57px; min-width: 57px"
                  v-show="
                    orgTypeFilter.type == 'org_facing_college' ||
                    orgTypeFilter.type == 'org_facing_transfer' ||
                    orgTypeFilter.type == 'org_facing_otis'
                  "
                  class="text-center"
                >
                  <div>Reply?</div>
                  <button
                    class="btn btn-default"
                    v-on:click="filterListByReplies()"
                  >
                    <span
                      v-if="replyFilter === 1"
                      id="icon-filter-orange"
                    ></span>
                    <span v-else id="icon-filter-grey"></span>
                  </button>
                </th>
                <th
                  data-ref="org_has_recruited"
                  style="max-width: 77px; min-width: 77px"
                  v-show="
                    org_has_recruited &&
                    (orgTypeFilter.type == 'org_facing_college' ||
                      orgTypeFilter.type == 'org_facing_transfer' ||
                      orgTypeFilter.type == 'org_facing_otis' ||
                      orgTypeFilter.type == 'org_facing_otis_transfer' ||
                      orgTypeFilter.type == 'org_facing_otis_hs' ||
                      orgTypeFilter.type == 'org_facing_otis_flyin')
                  "
                  class="text-center"
                >
                  <div class="re-tooltip">
                    <div>Recruited</div>
                    <button
                      class="btn btn-default"
                      v-on:click="filterListByRecruited()"
                    >
                      <img
                        v-show="recruitedFilter"
                        width="16px"
                        :src="
                          staticaddr + '/s/img/_shared/icon-iv-referred.png'
                        "
                      />
                      <img
                        v-show="!recruitedFilter"
                        width="16px"
                        :src="
                          staticaddr +
                          '/s/img/_shared/icon-iv-referred-grey.png'
                        "
                      />
                    </button>
                  </div>
                </th>
                <th
                  data-ref="interview"
                  style="max-width: 77px; min-width: 77px"
                >
                  <div class="text-center">
                    {{
                      orgTypeFilter.type == "org_facing_viva"
                        ? "Viva"
                        : "Interview"
                    }}
                  </div>
                </th>
                <th
                  data-cy="columnHeader-status"
                  data-ref="status"
                  style="max-width: 102px; min-width: 102px"
                  v-bind:class="{
                    'sorted-column': orderByColumn == 'reviewStatus',
                  }"
                >
                  <div class="text-center">Status</div>
                  <select
                    data-cy="filterSelect-status"
                    class="form-control input-sm"
                    v-model="filterObject.reviewStatus"
                  >
                    <option value="">All</option>
                    <option
                      v-bind:value="op.value"
                      v-for="op in reviewStatusOptions"
                      v-bind:key="op.value"
                    >
                      {{ op.text }}
                    </option>
                  </select>
                </th>

                <th
                  data-cy="columnHeader-reviewScoreAve"
                  data-ref="reviewScoreAve"
                  v-show="orgTypeFilter.type != 'org_facing_viva'"
                  v-bind:class="{
                    'sorted-column': orderByColumn == 'reviewScoreAve',
                  }"
                  style="max-width: 100px; min-width: 100px"
                >
                  <div class="text-center">
                    Score
                    <span
                      v-if="orderByColumn == 'reviewScoreAve'"
                      v-on:click="sortOrder = sortOrder * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder > 0,
                          'glyphicon-menu-down': sortOrder < 0,
                        }"
                      ></i>
                    </span>
                    <span
                      v-if="orderByColumn2 == 'reviewScoreAve'"
                      v-on:click="sortOrder2 = sortOrder2 * -1"
                    >
                      <i
                        class="glyphicon"
                        v-bind:class="{
                          'glyphicon-menu-up': sortOrder2 > 0,
                          'glyphicon-menu-down': sortOrder2 < 0,
                        }"
                      ></i>
                    </span>
                  </div>
                  <div>
                    <select
                      data-cy="filterSelect-reviewScoreAve"
                      class="form-control input-sm"
                      v-model="filterObject.rated"
                    >
                      <option
                        v-bind:value="op.value"
                        v-for="op in ratedOptions"
                        v-bind:key="op.value"
                      >
                        {{ op.text }}
                      </option>
                    </select>
                  </div>
                  <div v-show="filterObject.rated == 1">
                    <input id="rangescore" type="text" />
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div
          class="container"
          id="list-view"
          data-cy="interviewList"
          style="min-width: 1394px"
          v-bind:style="{ top: filterObject.rated == 1 ? '247px' : '191px' }"
        >
          <!-- 			<virtual-scroller v-bind:items="sortedInterviews" item-height="59" content-tag="table" content-class="table table-bordered table-striped">
				<template slot-scope="props">
 -->
          <div v-on:scroll="handleScroll" id="scrollable">
            <div
              style="box-sizing: border-box; width: 100%; overflow: hidden"
              v-bind:style="itemContainerStyle"
            >
              <table
                class="table table-bordered table-striped"
                v-bind:style="itemsStyle"
              >
                <tbody>
                  <tr
                    v-for="(propsitem, propsitemIndex) in visibleInterviews"
                    v-bind:data-cy="'interviewEntry-' + propsitem.id"
                    v-bind:key="propsitem.id"
                    v-bind:class="{
                      info: propsitem.reviewStatus == '1',
                      success: propsitem.reviewStatus == '2',
                    }"
                  >
                    <td
                      v-on:click.prevent.stop="
                        RowClick(
                          sortedInterviews,
                          propsitem,
                          propsitemIndex + $_startIndex,
                          $event,
                        )
                      "
                      v-bind:style="{
                        'text-shadow':
                          propsitemIndex + $_startIndex == lastSelectedRowIndex
                            ? '2px 2px 9px #999'
                            : 'none',
                        width: colWidths.select,
                      }"
                      style="font-size: larger"
                    >
                      <span
                        v-show="!propsitem.checked"
                        class="glyphicon glyphicon-unchecked"
                        style="color: #777"
                      ></span>
                      <span
                        v-show="propsitem.checked"
                        class="glyphicon glyphicon-check"
                        style="color: #e96724"
                      ></span>
                    </td>
                    <td v-bind:style="{ width: colWidths.dateReceived }">
                      <div data-cy="interview-dateReceived">
                        {{ dateFormat(propsitem.dateReceived) }}
                      </div>
                    </td>
                    <td v-bind:style="{ width: colWidths.lastName }">
                      <div data-cy="interview-lastName">
                        {{ propsitem.lastName }}
                      </div>
                    </td>
                    <td v-bind:style="{ width: colWidths.firstName }">
                      <div data-cy="interview-firstName">
                        {{ propsitem.firstName }}
                      </div>
                    </td>
                    <td v-bind:style="{ width: colWidths.dateOfBirth }">
                      <div data-cy="interview-dateOfBirth">
                        {{ propsitem.dateOfBirth }}
                      </div>
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.appid }"
                      v-show="
                        orgTypeFilter.type == 'org_facing_college' ||
                        orgTypeFilter.type == 'org_facing_transfer' ||
                        orgTypeFilter.type == 'org_facing_otis' ||
                        orgTypeFilter.type == 'org_facing_viva'
                      "
                    >
                      <div
                        v-for="appId in propsitem.applicationIds"
                        v-bind:key="appId.name"
                        data-toggle="tooltip"
                        data-container="body"
                        v-bind:title="appId.name"
                      >
                        <div>{{ appId.abbr }}: {{ appId.value || "" }}</div>
                      </div>
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.email }"
                      v-bind:title="propsitem.email"
                    >
                      <div data-cy="interview-email">
                        {{ propsitem.email }}
                      </div>
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.org_facing_star }"
                      class="list-star"
                      v-show="
                        orgTypeFilter.type == 'org_facing_college' ||
                        orgTypeFilter.type == 'org_facing_transfer' ||
                        orgTypeFilter.type == 'org_facing_otis'
                      "
                    >
                      <img
                        v-show="propsitem.star"
                        width="40px"
                        :src="staticaddr + '/s/img/_shared/OrangeStar.png'"
                      />
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.org_facing_rose }"
                      class="list-rose"
                      v-show="
                        orgTypeFilter.type == 'org_facing_college' ||
                        orgTypeFilter.type == 'org_facing_transfer' ||
                        orgTypeFilter.type == 'org_facing_otis'
                      "
                      style="text-align: center"
                    >
                      <img
                        v-show="propsitem.rose"
                        height="30px"
                        :src="
                          staticaddr +
                          '/ivgcs/img/lone-yellow-rose-transparent.png'
                        "
                        style="margin-top: 5px"
                      />
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.org_facing_reply }"
                      class="list-reply"
                      v-show="
                        orgTypeFilter.type == 'org_facing_college' ||
                        orgTypeFilter.type == 'org_facing_transfer' ||
                        orgTypeFilter.type == 'org_facing_otis'
                      "
                    >
                      <p
                        v-show="
                          propsitem.video_reply &&
                          !propsitem.ivee_read &&
                          !propsitem.ivee_thanks
                        "
                        data-toggle="tooltip"
                        title="You sent a video reply to this student."
                      >
                        <span id="icon-sent"></span>
                      </p>
                      <p
                        v-show="
                          propsitem.video_reply &&
                          propsitem.ivee_read &&
                          !propsitem.ivee_thanks
                        "
                        data-toggle="tooltip"
                        title="This student viewed your video reply."
                      >
                        <span id="icon-seen"></span>
                      </p>
                      <p
                        v-show="propsitem.video_reply && propsitem.ivee_thanks"
                        data-toggle="tooltip"
                        title="This student thanked you for your video reply."
                      >
                        <span id="icon-thanks"></span>
                      </p>
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.org_has_recruited }"
                      class="list-recruited text-center"
                      v-show="
                        org_has_recruited &&
                        (orgTypeFilter.type == 'org_facing_college' ||
                          orgTypeFilter.type == 'org_facing_transfer' ||
                          orgTypeFilter.type == 'org_facing_otis' ||
                          orgTypeFilter.type == 'org_facing_otis_transfer' ||
                          orgTypeFilter.type == 'org_facing_otis_hs' ||
                          orgTypeFilter.type == 'org_facing_otis_flyin')
                      "
                    >
                      <div v-if="propsitem.recruited">
                        <img
                          width="40px"
                          :src="
                            staticaddr + '/s/img/_shared/icon-iv-referred.png'
                          "
                        />
                      </div>
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.interview }"
                      id="videoLinkBox"
                      v-on:click.prevent="linkTo(propsitem.ivVideo)"
                    >
                      <div class="centerLinks">
                        <a>Watch</a>
                        <br />
                        <img
                          width="40px"
                          :src="
                            staticaddr + '/s/img/organization/VideoCamera.png'
                          "
                        />
                        <br />
                      </div>
                    </td>

                    <td v-bind:style="{ width: colWidths.status }">
                      <select
                        class="form-control input-sm"
                        id="list-dropdown"
                        data-cy="interview-status"
                        v-model="propsitem.reviewStatus"
                        v-on:change="
                          updateReviewStatus(propsitem, propsitem.reviewStatus)
                        "
                      >
                        <option
                          v-for="option in reviewStatusOptions"
                          v-bind:key="option.text"
                          v-bind:value="option.value"
                        >
                          {{ option.text }}
                        </option>
                      </select>
                      <!-- <span>Selected: {{ propsitem.reviewStatus }}</span> -->
                    </td>
                    <td
                      v-bind:style="{ width: colWidths.reviewScoreAve }"
                      class="review-score"
                      v-show="orgTypeFilter.type != 'org_facing_viva'"
                      data-toggle="tooltip"
                      data-placement="left"
                      data-container="body"
                      data-html="true"
                      data-template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner comments"></div></div>'
                      style="white-space: nowrap"
                      v-bind:title="getReviews(propsitem)"
                    >
                      <div data-cy="interview-reviewScoreAve">
                        {{ propsitem.reviewScoreAve }}
                      </div>
                    </td>
                  </tr>
                  <!-- 				</template>
</virtual-scroller>
-->
                </tbody>
              </table>
            </div>
          </div>
          <!-- END OF LIST VIEW -->
        </div>
      </div>

      <div class="container" v-show="current_view == 'settings'">
        <AmeliaSettings
          v-bind:ameliaaddr="ameliaaddr"
          v-bind:settingsSlateURL="settingsSlateURL"
          v-bind:org_cycles="org_cycles"
          v-bind:orgTypes="orgTypes"
          v-model="filter_cycle"
          v-on:startTimer="startTimer"
        />
        <!-- End of Settings View -->
      </div>

      <div class="container" v-show="current_view == 'search'">
        <AmeliaSearch
          v-bind:ameliaaddr="ameliaaddr"
          v-bind:settingsSlateURL="settingsSlateURL"
          v-bind:org_cycles="org_cycles"
          v-bind:orgTypes="orgTypes"
          v-model="filter_cycle"
          v-on:startTimer="startTimer"
        />
      </div>

      <div class="container" v-show="current_view == 'ranking'">
        <AmeliaRanking v-bind:ameliaaddr="ameliaaddr" />
      </div>

      <!-- Begin Feewaiver View -->
      <div class="container" v-show="current_view == 'feewaiver'">
        <AmeliaFeeWaiver
          v-bind:fee_waivers="fee_waivers"
          v-bind:feewaiverRequestStatus="feewaiverRequestStatus"
          v-on:sendFeeWaiver="sendFeeWaiver"
          v-on:requestMoreFeeWaivers="requestMoreFeeWaivers"
        />
      </div>
      <!-- Begin Admin View -->
      <div class="container" v-show="current_view == 'admin'">
        <div class="row">
          <h4>Invite a new Amelia user to your Organization</h4>

          <div class="row">
            <div class="col-xs-4">
              <br />
              <form class="form-horizontal">
                <div class="form-group">
                  <label for="input2" class="col-xs-4 control-label">
                    Email
                  </label>
                  <div class="col-xs-8">
                    <input
                      type="text"
                      class="form-control"
                      id="inviteUserEmail"
                      placeholder="user@example.edu"
                      v-model="inviteUserEmail"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      v-on:click.prevent="invite_new_user()"
                    >
                      Send Invite
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- end: container -->

      <!-- Modal -->
      <div
        class="modal"
        id="ivTypeModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        data-backdrop="static"
      >
        <div
          class="modal-dialog modal-md"
          role="document"
          style="margin-top: 200px"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">
                Choose an Applicant Type
              </h4>
            </div>
            <div class="modal-body" style="overflow: hidden">
              <div style="z-index: -10">
                <div class="orange-circle"></div>
                <div class="blue-circle"></div>
              </div>
              <div class="row" v-if="activate_tt">
                <div class="col-xs-12">
                  <div
                    class="panel panel-default hovergray"
                    v-on:click="goToHref('/tuesday-talks')"
                  >
                    <!-- <svg style="
                        position: absolute;
                        width: 54px;
                        top: -7px;
                        right: 24px;
                      " width="76" height="31" viewBox="0 0 76 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="76" height="31" fill="#E96724" />
                      <path
                        d="M13.2165 9.04C13.3365 9.04 13.4365 9.04667 13.5165 9.06C13.5965 9.06667 13.6665 9.08667 13.7265 9.12C13.7932 9.14667 13.8565 9.19 13.9165 9.25C13.9765 9.30333 14.0432 9.37667 14.1165 9.47L21.7065 19.14C21.6798 18.9067 21.6598 18.68 21.6465 18.46C21.6398 18.2333 21.6365 18.0233 21.6365 17.83V9.04H24.0065V23.5H22.6165C22.4032 23.5 22.2265 23.4667 22.0865 23.4C21.9465 23.3333 21.8098 23.2133 21.6765 23.04L14.1165 13.41C14.1365 13.6233 14.1498 13.8367 14.1565 14.05C14.1698 14.2567 14.1765 14.4467 14.1765 14.62V23.5H11.8065V9.04H13.2165ZM36.2437 9.04V11.18H29.8337V15.19H34.8837V17.26H29.8337V21.35H36.2437V23.5H27.1237V9.04H36.2437ZM37.429 9.04H39.689C39.9223 9.04 40.1157 9.09667 40.269 9.21C40.429 9.31667 40.5357 9.46333 40.589 9.65L43.049 18.3C43.109 18.5133 43.1623 18.7467 43.209 19C43.2623 19.2467 43.3123 19.51 43.359 19.79C43.4123 19.51 43.469 19.2467 43.529 19C43.5957 18.7467 43.6657 18.5133 43.739 18.3L46.579 9.65C46.6323 9.49667 46.7357 9.35667 46.889 9.23C47.049 9.10333 47.2423 9.04 47.469 9.04H48.259C48.4923 9.04 48.6857 9.09667 48.839 9.21C48.9923 9.31667 49.099 9.46333 49.159 9.65L51.979 18.3C52.1257 18.7267 52.2523 19.2 52.359 19.72C52.4057 19.46 52.4523 19.21 52.499 18.97C52.5523 18.73 52.6057 18.5067 52.659 18.3L55.119 9.65C55.1657 9.48333 55.269 9.34 55.429 9.22C55.589 9.1 55.7823 9.04 56.009 9.04H58.119L53.629 23.5H51.199L48.039 13.62C47.999 13.4933 47.9557 13.3567 47.909 13.21C47.869 13.0633 47.829 12.9067 47.789 12.74C47.749 12.9067 47.7057 13.0633 47.659 13.21C47.619 13.3567 47.579 13.4933 47.539 13.62L44.349 23.5H41.919L37.429 9.04ZM63.2465 9.04V14.76C63.2465 15.3667 63.2165 15.9633 63.1565 16.55C63.0965 17.13 63.0165 17.7467 62.9165 18.4H61.2465C61.1465 17.7467 61.0665 17.13 61.0065 16.55C60.9465 15.9633 60.9165 15.3667 60.9165 14.76V9.04H63.2465ZM60.5365 22.14C60.5365 21.9333 60.5732 21.7367 60.6465 21.55C60.7265 21.3633 60.8332 21.2033 60.9665 21.07C61.1065 20.9367 61.2698 20.83 61.4565 20.75C61.6432 20.67 61.8432 20.63 62.0565 20.63C62.2632 20.63 62.4598 20.67 62.6465 20.75C62.8332 20.83 62.9932 20.9367 63.1265 21.07C63.2598 21.2033 63.3665 21.3633 63.4465 21.55C63.5265 21.7367 63.5665 21.9333 63.5665 22.14C63.5665 22.3533 63.5265 22.5533 63.4465 22.74C63.3665 22.92 63.2598 23.0767 63.1265 23.21C62.9932 23.3433 62.8332 23.4467 62.6465 23.52C62.4598 23.6 62.2632 23.64 62.0565 23.64C61.8432 23.64 61.6432 23.6 61.4565 23.52C61.2698 23.4467 61.1065 23.3433 60.9665 23.21C60.8332 23.0767 60.7265 22.92 60.6465 22.74C60.5732 22.5533 60.5365 22.3533 60.5365 22.14Z"
                        fill="white" />
                    </svg> -->
                    <div
                      class="panel-body row"
                      style="padding-top: 0px; padding-bottom: 0px"
                    >
                      <div class="col-xs-12">
                        <div class="text-center">Tuesday Talks</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-for="orgType in orgTypes"
                v-bind:key="orgType.label"
              >
                <div class="col-xs-12">
                  <div
                    v-bind:data-cy="'choose_' + orgType.type"
                    class="panel panel-default hovergray"
                    v-on:click="changeOrgTypeFilter(orgType)"
                    data-dismiss="modal"
                  >
                    <div
                      class="panel-body row"
                      style="padding-top: 0px; padding-bottom: 0px"
                    >
                      <div class="col-xs-12">
                        <div class="text-center">{{ orgType.label }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal"
        id="orgModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        data-backdrop="static"
      >
        <div
          class="modal-dialog modal-sm"
          role="document"
          style="margin-top: 200px"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">Choose a Program</h4>
            </div>
            <div class="modal-body">
              <div class="row" v-for="org in orgs" v-bind:key="org.org_code">
                <div class="col-xs-12">
                  <div
                    class="panel panel-default hovergray"
                    v-on:click="changeOrg(org)"
                    data-dismiss="modal"
                  >
                    <div
                      class="panel-body row"
                      style="padding-top: 0px; padding-bottom: 0px"
                    >
                      <div class="col-xs-12">
                        <div class="text-center">{{ org.org_name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="starreport"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        style="z-index: 1000001"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                Star Report for the Current Admissions Cycle
              </h4>
            </div>
            <div class="modal-body">
              <div id="star-modal-container"></div>
              <table class="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <td>
                      Total Stars (as of today's date)
                      <i
                        class="glyphicon glyphicon-info-sign"
                        data-toggle="tooltip"
                        data-container="#star-modal-container"
                        title="Each interviewee receives only two virtual stars to assign to target schools"
                      ></i>
                    </td>
                    <td>
                      {{ starreport.total_stars }}
                    </td>
                  </tr>
                  <tr>
                    <td>Total Interviews (as of today's date)</td>
                    <td>
                      {{ starreport.total_interviews }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Current Star Ratio
                      <i
                        class="glyphicon glyphicon-info-sign"
                        data-toggle="tooltip"
                        data-container="#star-modal-container"
                        title="Total number of stars divided by total number of interviews"
                      ></i>
                    </td>
                    <td>
                      {{ starreport.star_ratio }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>
                <a
                  data-toggle="tooltip"
                  data-container="#star-modal-container"
                  data-placement="right"
                  title="The best way to increase your stars is to gently remind students to send their interview (many use language similar to the following in an email: “If you have already completed your InitialView interview, please don’t forget to send it to us”)."
                >
                  Tips for Increasing Number of Stars
                  <i class="glyphicon glyphicon-info-sign"></i>
                </a>
              </p>
              <p>Interviews from students located in:</p>
              <div style="max-height: 300px; overflow-y: scroll">
                <table class="table table-striped table-bordered">
                  <tbody>
                    <tr
                      v-for="region in starreport.interviews_by_region"
                      v-bind:key="region.name"
                    >
                      <td>
                        {{ region.name }}
                      </td>
                      <td>
                        {{ region.count }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="epic-learn-modal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        style="z-index: 1000001"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Join EPIC!</h4>
            </div>
            <div class="modal-body">
              <div>
                <p>
                  Join EPIC to recruit domestic students! Contact us at
                  <a href="mailto:contact@initialview.com"
                    >contact@initialview.com</a
                  >
                  if you're interested and to learn more!
                </p>
                <p>
                  See other participating schools and learn more
                  <a href="https://initialview.com/epic" target="_blank">here</a
                  >.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="needHelp"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">We're here to help!</h4>
            </div>
            <div class="modal-body">
              <p>
                If you're having any trouble, write us a message below or email
                us at amelia@initialview.com!
              </p>
              <div class="form-group">
                <textarea
                  class="form-control"
                  v-model="supportMessage"
                  rows="3"
                  placeholder="For example: The interview for Suzie Suzeman is not loading (her email is suzie.suzemeister@gmail.com). I’ll also email you a screenshot of the issue. I am using Chrome Version 62 on a Mac."
                ></textarea>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <button
                    class="btn btn-success pull-right"
                    v-bind:disabled="!supportMessage"
                    v-on:click="submitListSupport()"
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div v-if="supportMessageSent" class="row">
                <div class="col-xs-12">
                  We've received your message! We’re monitoring these messages
                  24 hours a day. We’ll be in touch soon!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav
        class="navbar navbar-default navbar-fixed-bottom navbar-bottom"
        role="navigation"
      >
        <div class="container text-center">
          <p class="col-xs-12 navbar-text">
            <span>&copy; InitialView {{ currentYear }}</span
            ><span style="margin: 0 10px 0 10px">|</span>
            <a
              href="#"
              data-toggle="modal"
              data-target="#needHelp"
              style="color: #777"
            >
              <i class="glyphicon glyphicon-question-sign"></i>
              Having trouble with anything?
            </a>
          </p>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ivbus from "@/utils/ivbus.js";

require("@/utils/LoginRequired.js");

import {
  ivModalMixin,
  ivAlertMixin,
  ivSpinnerMixin,
  ivUserInfoMixin,
  ivChunkUploadMixin,
  getParameterByName,
} from "@/mixins/base-components-pack.js";

import { orgSupportMixin } from "@/mixins/org-support-mixin-pack.js";

import apiClient from "../utils/apiClient.js";

import moment from "moment-timezone";

import AmeliaSettings from "@/components/AmeliaSettings.vue";
import AmeliaSearch from "@/components/AmeliaSearch.vue";
import AmeliaRanking from "@/components/AmeliaRanking.vue";
import AmeliaFeeWaiver from "@/components/AmeliaFeeWaiver.vue";
import Pagination from "@/components/Pagination.vue";
import Alert from "@/components/Alert.vue";
import Spinner from "@/components/Spinner.vue";

import ionRangeSlider from "ion-rangeslider";

var slicer = function (paginator, array) {
  // update paginator
  paginator.total = array.length;
  paginator.total_pages = Math.ceil(paginator.total / paginator.per_page);
  if (paginator.current_page > paginator.total_pages) {
    paginator.current_page = paginator.total_pages;
  }
  if (paginator.current_page == 0) {
    paginator.current_page = 1;
  }

  return array.slice(
    paginator.per_page * (paginator.current_page - 1),
    paginator.per_page * paginator.current_page,
  );
};

export default {
  mixins: [
    ivModalMixin,
    ivAlertMixin,
    ivSpinnerMixin,
    ivUserInfoMixin,
    orgSupportMixin,
    ivChunkUploadMixin,
  ],

  props: ["staticaddr", "serveraddr", "ameliaaddr", "lang", "lang_label"],

  components: {
    AmeliaSettings,
    AmeliaSearch,
    AmeliaRanking,
    AmeliaFeeWaiver,
    Pagination,
    Alert,
    Spinner,
  },

  data() {
    return {
      is_power_user: false,
      currentYear: new Date().getFullYear(),
      // navigation
      current_view: "list",
      headers: {
        list: " ",
        search: " ",
        ranking: " ",
        settings: " ",
        feewaiver: " ",
        admin: " ",
      },

      activate_tt: false,

      supportMessage: "",
      supportEmail: "",
      supportMessageSent: "",

      // org data
      orgName: "",
      orgSlateToken: "",
      org_code: "",
      colWidths: {},
      zipRequests: {},

      // list view and filter
      interviews: [],
      //			filteredInterviews: [],

      starreport: {},
      filter_cycle: null,
      active_cycle: null,
      org_cycles: [],
      underGrad: null,
      orgType: null,

      reviewStatusOptions: [
        // cf
        // organization/models/ReviewStatus/ReviewStatusChoices
        {
          text: "Not Started",
          value: "0",
        },
        {
          text: "In Progress",
          value: "1",
        },
        {
          text: "Complete",
          value: "2",
        },
      ],
      ratedOptions: [
        {
          text: "All",
          value: "0",
        },
        {
          text: "Rated",
          value: "1",
        },
        {
          text: "Unrated",
          value: "2",
        },
      ],
      // filter fields
      filterObject: {
        dateReceived: "",
        lastName: "",
        firstName: "",
        dateOfBirth: "",
        appId: "",
        email: "",
        reviewStatus: "",
        rated: "0",
        scoreLow: 1,
        scoreHigh: 5,
      },
      filterTimer: null,
      // filter by star
      starFilter: "",
      //filter by rose
      roseFilter: "",
      // filter by reply
      replyFilter: "",
      // filter by recruited
      recruitedFilter: "",
      orgTypes: [],
      orgTypeFilter: {},

      orgs: [],

      page_num: 1,
      page_size: 50,

      org_has_recruited: false,

      // sort columns
      orderByColumn: "dateReceived",
      orderByColumn2: "",
      sortOrder: -1,
      sortOrder2: 0,

      // settings page
      settingsSlateURL: "",

      fee_waivers: [],
      feewaiverRequestStatus: "pristine",
      modalWaiver: null,

      inviteUserEmail: "",

      oldpass: "",
      newpass1: "",
      newpass2: "",

      lastSelectedRow: null,
      lastSelectedRowIndex: null,

      // virtual scrolling:
      $_startIndex: 0,
      itemContainerStyle: null,
      itemsStyle: null,
      scroll: {
        top: 0,
        bottom: 0,
      },

      // generate report from upload
      reportExcel: {
        fileUrl: null,
        fileIsImage: false,
      },
      excelUploadProgress: null,
    };
  },
  created: function () {
    var that = this;
    this.ivTwilio = {};
    location.hash = "";
    location.hash = "list";

    $(window).on("hashchange", function () {
      var new_view = location.hash.slice(1);
      console.log(new_view);
      if (that.headers[new_view]) {
        console.log("if");
        that.current_view = new_view;
      } else {
        console.log("else");
        that.current_view = "list";
      }
      console.log(that.current_view);
      if (that.current_view == "list") {
        window.setTimeout(function () {
          that.cacheColWidths();
        });
      }
    });
  },
  computed: {
    ChannelListSorted: function () {
      var that = this;
      return slicer(
        that.channelPagination,
        that.channelsList.sort(function (a, b) {
          // desired: first sort by latest received message, then by latest sent message if the student has never responded
          // actual for now: sort by latest received message if student sent most recent message, then by latest sent message if org sent most recent message
          // consider sorting channels with unread messages higher
          var atime =
            a.last_message_sent_by == that.identity
              ? "xxx" + a.last_message_sent_at
              : "yyy" + a.last_message_sent_at;
          var btime =
            b.last_message_sent_by == that.identity
              ? "xxx" + b.last_message_sent_at
              : "yyy" + b.last_message_sent_at;

          return atime < btime ? 1 : atime > btime ? -1 : 0;
        }),
      );
    },
    isNotPowerUser: function () {
      return !this.is_power_user;
    },
    filteredInterviews: function () {
      var that = this;
      that.page_num = 1;
      that.lastSelectedRow = null;
      that.lastSelectedRowIndex = null;
      return that.interviews.filter(function (iv) {
        var match = true;
        iv.checked = false;
        if (match && that.filterObject.dateReceived) {
          match =
            iv.dateReceived &&
            iv.dateReceived
              .toLowerCase()
              .indexOf(that.filterObject.dateReceived.toLowerCase()) !== -1;
        }
        if (match && that.filterObject.lastName) {
          match =
            iv.lastName &&
            iv.lastName
              .toLowerCase()
              .indexOf(that.filterObject.lastName.toLowerCase()) !== -1;
        }
        if (match && that.filterObject.firstName) {
          match =
            iv.firstName &&
            iv.firstName
              .toLowerCase()
              .indexOf(that.filterObject.firstName.toLowerCase()) !== -1;
        }
        if (match && that.filterObject.dateOfBirth) {
          match =
            iv.dateOfBirth &&
            iv.dateOfBirth
              .toLowerCase()
              .indexOf(that.filterObject.dateOfBirth.toLowerCase()) !== -1;
        }
        if (match && that.filterObject.appId) {
          match =
            iv.applicationIds &&
            iv.applicationIds.filter(function (aid) {
              return (
                aid.value &&
                aid.value
                  .toLowerCase()
                  .indexOf(that.filterObject.appId.toLowerCase()) !== -1
              );
            }).length > 0;
        }
        if (match && that.filterObject.email) {
          match =
            iv.email &&
            iv.email
              .toLowerCase()
              .indexOf(that.filterObject.email.toLowerCase()) !== -1;
        }
        if (match && that.starFilter) {
          match = iv.star == true;
        }
        if (match && that.roseFilter) {
          match = iv.rose == true;
        }
        if (match && that.replyFilter) {
          match = iv.video_reply == true;
        }
        if (match && that.recruitedFilter) {
          match = iv.recruited == true;
        }
        if (match && that.filterObject.rated > 0) {
          match =
            that.filterObject.rated == 1
              ? !!iv.reviewScoreAve
              : that.filterObject.rated == 2
                ? !iv.reviewScoreAve
                : true;
        }
        if (
          match &&
          that.filterObject.rated == 1 &&
          that.filterObject.scoreLow
        ) {
          match = iv.reviewScoreAve >= that.filterObject.scoreLow;
        }
        if (
          match &&
          that.filterObject.rated == 1 &&
          that.filterObject.scoreHigh
        ) {
          match = iv.reviewScoreAve <= that.filterObject.scoreHigh;
        }
        if (match && that.filterObject.reviewStatus) {
          match = iv.reviewStatus == that.filterObject.reviewStatus;
        } // check for 0 vs null
        return match;
      });
    },
    sortedInterviews: function () {
      var that = this;
      return this.filteredInterviews.slice().sort(function (a, b) {
        // Convert date strings to Date objects for proper comparison
        var aVal =
          that.orderByColumn === "dateReceived"
            ? new Date(a[that.orderByColumn])
            : a[that.orderByColumn] || "";
        var bVal =
          that.orderByColumn === "dateReceived"
            ? new Date(b[that.orderByColumn])
            : b[that.orderByColumn] || "";
        var a2Val = that.orderByColumn2
          ? that.orderByColumn2 === "dateReceived"
            ? new Date(a[that.orderByColumn2])
            : a[that.orderByColumn2] || ""
          : "";
        var b2Val = that.orderByColumn2
          ? that.orderByColumn2 === "dateReceived"
            ? new Date(b[that.orderByColumn2])
            : b[that.orderByColumn2] || ""
          : "";

        var so = that.sortOrder;
        var so2 = that.sortOrder2;

        // Handle date comparisons
        if (that.orderByColumn === "dateReceived") {
          return aVal > bVal
            ? so
            : aVal < bVal
              ? -1 * so
              : a2Val > b2Val
                ? so2
                : a2Val < b2Val
                  ? -1 * so2
                  : 0;
        }

        // Handle non-date comparisons
        return aVal < bVal
          ? so
          : aVal > bVal
            ? -1 * so
            : a2Val > b2Val
              ? so2
              : a2Val < b2Val
                ? -1 * so2
                : 0;
      });
    },
    selectedInterviews: function () {
      return this.filteredInterviews.filter(function (iv) {
        return iv.checked;
      }).length;
    },
    visibleInterviews: function () {
      var _this2 = this;
      var l = _this2.sortedInterviews.length;
      var itemHeight = 59;
      var containerHeight = void 0,
        offsetTop = void 0;
      var scroll = this.scroll;
      if (scroll) {
        var startIndex = -1;
        var endIndex = -1;

        var buffer = 200;
        var poolSize = 2000;
        var scrollTop = ~~(scroll.top / poolSize) * poolSize - buffer;
        var scrollBottom =
          Math.ceil(scroll.bottom / poolSize) * poolSize + buffer;

        // if ((scrollTop === _this2.$_oldScrollTop && scrollBottom === _this2.$_oldScrollBottom) || _this2.$_skip) {
        //   _this2.$_skip = false;
        //   return;
        // } else {
        _this2.$_oldScrollTop = scrollTop;
        _this2.$_oldScrollBottom = scrollBottom;
        // }

        // Fixed height mode
        startIndex = ~~(scrollTop / itemHeight);
        endIndex = Math.ceil(scrollBottom / itemHeight);

        // Bounds
        startIndex < 0 && (startIndex = 0);
        endIndex > l && (endIndex = l);

        offsetTop = startIndex * itemHeight;
        containerHeight = l * itemHeight;

        if (
          _this2.$_startIndex !== startIndex ||
          _this2.$_endIndex !== endIndex ||
          _this2.$_offsetTop !== offsetTop ||
          _this2.$_height !== containerHeight ||
          _this2.$_length !== l
        ) {
          _this2.keysEnabled = !(
            startIndex > _this2.$_endIndex || endIndex < _this2.$_startIndex
          );

          Vue.set(_this2, "itemContainerStyle", {
            height: containerHeight + "px",
          });
          Vue.set(_this2, "itemsStyle", {
            marginTop: offsetTop + "px",
          });

          _this2.$_startIndex = startIndex;
          _this2.$_endIndex = endIndex;
          _this2.$_length = l;
          _this2.$_offsetTop = offsetTop;
          _this2.$_height = containerHeight;
        }
      }

      _this2.resetReviewTooltips();

      return this.sortedInterviews.slice(
        _this2.$_startIndex,
        _this2.$_endIndex,
      );
    },
  },
  mounted: function () {
    var that = this;

    // Special case where user came from initialview login page with pre-authorized persisted (LocalStorage) apitoken via iframe
    // For security: we don't want it in LocalStorage.
    // We need to remove the persisted apitoken and move it into temporary (SessionStorage).
    if (localStorage.apitoken !== undefined) {
      sessionStorage.apitoken = localStorage.apitoken;
      localStorage.removeItem("apitoken");
    }

    // fetchOrgInfo
    console.log("fetching organization");
    var spinId = that.spinStart();
    apiClient
      .get("/api/user/user_org_info/")
      .then(function (response) {
        that.spinStop(spinId);
        that.set("orgs", response.data.orgs);
        if (that.orgs.length && getParameterByName("o") != 1) {
          // show the org selector
          $("#orgModal").modal("show");
          return;
        }
        that.set("is_power_user", response.data.is_power_user);
        that.set("fee_waivers", response.data.fee_waivers);
        that.set("orgName", response.data.org.org_name);
        that.set("orgType", response.data.org.org_facing_iv_type_groups);
        that.set("orgSlateToken", response.data.org.org_slate_token);
        that.set("org_code", response.data.org.org_code);
        that.set(
          "settingsSlateURL",
          "https://initialview.com/api/slate/interviews/" +
            that.orgSlateToken +
            "/?start={{dtstart|date:'s'}}Z&end={{dtend|date:'s'}}Z",
        );
        that.set("filter_cycle", response.data.org.active_cycle.cycle_id); // default filter cycle
        that.set("active_cycle", response.data.org.active_cycle);
        that.set("org_cycles", response.data.org.cycles);
        that.set("org_has_recruited", response.data.org.has_recruited);
        that.set("activate_tt", response.data.activate_tt);

        $(".re-tooltip")
          .tooltip({
            trigger: "manual",
            html: true,
            animation: false,
            placement: "bottom",
            container: "body",
            title:
              'This student sent their interview to you after sending their interview to a peer school, as determined by a proprietary "suggestion" algorithm. Learn more about how to take advantage of this process <a href="/re-info/?v=' +
              that.org_has_recruited +
              '" target="_blank">here</a>.',
          })
          .on("mouseenter", function () {
            var _this = that;
            $(that).tooltip("show");
            $(".tooltip").on("mouseleave", function () {
              $(_this).tooltip("hide");
            });
          })
          .on("mouseleave", function () {
            var _this = that;
            setTimeout(function () {
              if (!$(".tooltip:hover").length) {
                $(_this).tooltip("hide");
              }
            }, 300);
          });

        that.setupRating();
        that.showIvTypeSelector(response.data.org.org_facing_iv_type_groups);
      })
      .catch(function (error) {
        that.spinStop(spinId);
        console.log(error);
      });

    var that = this;
    $(window).on("load", function () {
      window.setTimeout(function () {
        that.cacheColWidths();
        that.handleScroll();
      });
    });
    $(window).on("resize", that.cacheColWidths);

    // TODO: connect to wss with authentication, and establish main onmessage handler such that code below
    // can register handlers for different message types.

    $('[data-toggle="tooltip"]').tooltip();
    this.orgCheck();
  },
  methods: {
    goToHref: function (href) {
      window.location = href;
    },
    set(name, val) {
      // same as Vue.set
      // prevent undefined data from causing unexpective behavior
      if (val != undefined) {
        Vue.set(this, name, val);
      }
    },
    uploadGenerateReportFromFile() {
      var that = this;
      var spinId = that.spinStart();
      var file = this.$refs.generateReportFromFile;
      var excel = file.files[0];
      var msg = that.showMessage("Processing report...", "alert-warning");

      var end = () => {
        that.spinStop(spinId);
        that.hideMessage(msg);
        // reset file
        file.type = "text";
        file.type = "file";
      };
      this.chunkUpload(
        that.serveraddr + "/tus_files/",
        excel,
        that,
        "excelUploadProgress",
        function (resource_id) {
          window.setTimeout(function () {
            apiClient
              .post("/api/org/report/", { source: resource_id })
              .then(function (response) {
                var fileName = response.body.data.file_name;
                var iframe = document.getElementById("hiddenDownloader");
                if (iframe === null) {
                  iframe = document.createElement("iframe");
                  iframe.id = "hiddenDownloader";
                  iframe.style.visibility = "hidden";
                  document.body.appendChild(iframe);
                }
                iframe.src =
                  that.serveraddr + "/shield/mercury/file/" + fileName + "/";
                end();
              })
              .catch(function (error) {
                end();
                that.showMessage(
                  "Processing error, please try again! If the problem persists, please let us know at amelia@initialview.com!",
                  "alert-danger",
                  5000,
                );
              });
          }, 3000);
        },
        function (error) {
          end();
          switch (error.originalRequest.status) {
            case 413:
              that.alerts.uploadedWS = that.showMessage(
                "Uploaded file too big! Maximum file size is 10 MB.",
                "alert-danger",
              );
              break;
            default:
              that.alerts.uploadedWS = that.showMessage(
                "The upload didn't work! Please try again. If the problem persists, please let us know at amelia@initialview.com!",
                "alert-danger",
              );
          }
        },
      );
    },
    submitSupport: function () {
      var that = this;
      var vparam = getParameterByName("v");
      var spinId = that.spinStart();
      apiClient
        .post("/api/org/support/", {
          message: that.supportMessage,
          email: that.supportEmail || that.user.email,
          vparam: vparam,
        })
        .then(function (response) {
          that.spinStop(spinId);
          that.supportMessageSent = that.supportMessage;
          that.supportMessage = "";
        });
    },
    submitListSupport: function () {
      var that = this;
      var spinId = that.spinStart();
      apiClient
        .post("/api/org/support/", { message: that.supportMessage })
        .then(function (response) {
          that.spinStop(spinId);
          that.supportMessageSent = that.supportMessage;
          that.supportMessage = "";
        });
    },
    handleScroll: function () {
      var el = $("#scrollable")[0];
      var scroll = {
        top: el.scrollTop,
        bottom: el.scrollTop + el.clientHeight,
      };

      if (scroll.bottom >= 0 && scroll.top <= scroll.bottom) {
        Vue.set(this, "scroll", scroll);
      } else {
        Vue.set(this, "scroll", null);
      }
    },
    cacheColWidths: function () {
      var that = this;
      $("#listhead")
        .find("th")
        .each(function () {
          Vue.set(
            that.colWidths,
            $(this).attr("data-ref"),
            $(this).outerWidth() + "px",
          );
        });
    },
    dateFormat: function (date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },
    nextPage: function () {
      this.page_num += 1;
    },
    prevPage: function () {
      this.page_num -= 1;
    },
    resetReviewTooltips: function () {
      // Note: this requires rows be bound to the interview ID, not the index (v-bind:key="propsitem.id")
      // otherwise Vue reuses DOM elements when you filter, and tooltips get attached to the wrong rows
      var that = this;
      console.log("Reinitializing tooltips");
      // console.log('Review-score elements at start: ', $('[data-toggle="tooltip"].review-score'));
      // Destroy existing tooltips
      $('[data-toggle="tooltip"].review-score').tooltip("destroy");
      // Wait for DOM to update
      this.$nextTick(function () {
        window.setTimeout(function () {
          // console.log('Review-score elements after next tick: ', $('[data-toggle="tooltip"].review-score'));
          // Add tooltips back
          $('[data-toggle="tooltip"].review-score').tooltip();
        }, 200);
      });
    },
    filterListByStars: function () {
      this.starFilter = this.starFilter === 1 ? "" : 1;
    },
    filterListByRoses: function () {
      this.roseFilter = this.roseFilter === 1 ? "" : 1;
    },
    filterListByReplies: function () {
      this.replyFilter = this.replyFilter === 1 ? "" : 1;
    },
    filterListByRecruited: function () {
      this.recruitedFilter = this.recruitedFilter === 1 ? "" : 1;
    },
    fetchInterviewsWithFilters: function () {
      var that = this;
      if (this.filterTimer) {
        window.clearTimeout(this.filterTimer);
        this.filterTimer = null;
      }
      var params = {
        // 	"dateReceived": this.filterObject.dateReceived,
        // 	"firstName": this.filterObject.firstName,
        // 	"lastName": this.filterObject.lastName,
        // 	"rated": this.filterObject.rated,
        // 	"reviewStatus": this.filterObject.reviewStatus,
        // 	"dateOfBirth": this.filterObject.dateOfBirth,
        // 	"email": this.filterObject.email,
        // 	"stars": this.starFilter,
        // 	"recruited": this.recruitedFilter,
        // 	"page_num": this.filterObject.page_num,
        // 	"page_size": this.filterObject.page_size,
        // 	"ratedScoreLow": this.filterObject.scoreLow,
        // 	"ratedScoreHigh": this.filterObject.scoreHigh,
        // 	"appId": this.filterObject.appId,
        // 	"orderByColumn": this.orderByColumn,
        // 	"sortOrder": this.sortOrder,
        org_iv_type: this.orgTypeFilter.type,
        cycle_id: this.filter_cycle,
      };

      var spinId = this.spinStart();
      apiClient
        .get("/api/interview/admissions/list/", {
          params: params,
        })
        .then(function (interviews) {
          that.spinStop(spinId);
          Vue.set(that, "interviews", interviews.data.interviews);
          that.interviews.forEach(function (iv) {
            var date = new Date(iv["dateReceived"]);
            var isoString = date.toLocaleDateString();
            iv["dateReceived"] = isoString;
            Vue.set(iv, "checked", false);
          });
          that.cacheColWidths();

          // Vue.set(this.filterObject, 'num_pages', interviews.data.num_pages);
          // Vue.set(this.filterObject, 'page_num', interviews.data.page_num);
          // Vue.set(this.filterObject, 'page_size', interviews.data.page_size);

          that.resetReviewTooltips();
          if (that.interviews.length > 0) {
            console.log("fetching star report");
            apiClient
              .get("/api/interview/star_report/?v=" + that.interviews[0].sendId)
              .then(function (response) {
                console.log(response);
                if (response.data.status == "200") {
                  Vue.set(that, "starreport", response.data.data);
                } else {
                  that.starreport = {};
                  console.log(response.data.message);
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        })
        .catch(function (error) {
          this.spinStop(spinId);
          console.log(error);
        });
    },
    getReviews: function (iv) {
      var htmlStr = "";
      if (iv.reviews) {
        iv.reviews.forEach(function (r) {
          htmlStr +=
            "<p><i>" +
            r.reviewer +
            "</i>: [" +
            r.rating +
            "] " +
            r.comment +
            "</p>";
        });
      }

      return htmlStr;
    },
    startTimer: function () {
      // debounce
      if (this.filterTimer) {
        window.clearTimeout(this.filterTimer);
      }
      this.page_num = 1; // when filters are changed, return to page 1
      this.filterTimer = setInterval(this.fetchInterviewsWithFilters, 200);
    },
    changeOrgTypeFilter: function (orgType) {
      this.orgTypeFilter = orgType;
      this.fetchInterviewsWithFilters();
    },
    showIvTypeSelector: function (types) {
      var that = this;

      Vue.set(this, "orgTypes", types);

      if (this.orgTypes.length === 1) {
        this.orgTypeFilter = this.orgTypes[0];
        that.fetchInterviewsWithFilters();
      } else if (that.orgTypes.length > 1) {
        $("#ivTypeModal").modal("show");
      }
      this.orgCheck();
    },
    orgCheck: function () {
      var that = this;
      let checkList = [
        "org_facing_epic",
        "org_facing_college",
        "org_facing_transfer",
        "org_facing_otis",
        "org_facing_otis_transfer",
        "org_facing_otis_flyin",
        "org_facing_otis_summer",
        "org_facing_cadenza",
      ];
      console.log(this.orgType);
      console.log(checkList.includes(this.orgType[1].type));
      for (let i = 0; i < this.orgType.length; i++) {
        if (checkList.includes(this.orgType[i].type) != false) {
          this.underGrad = true;
          break;
        } else {
          this.underGrad = false;
        }
      }
    },
    changeOrg: function (org) {
      var that = this;
      var spinId = this.spinStart();
      apiClient
        .post("/api/user/update_user_org/", {
          org_code: org.org_code,
        })
        .then(function (response) {
          if (response.data.status == 200) {
            // don't turn off spinner - let the page refresh
            window.location =
              window.location.origin + window.location.pathname + "?o=1";
            //						window.location.refresh();
          } else {
            that.spinStop(spinId);
          }
        })
        .catch(function () {
          that.spinStop(spinId);
        });
    },
    setupRating: function () {
      var that = this;
      $("img").on("dragstart", function (event) {
        event.preventDefault();
      });

      $("#rangescore").ionRangeSlider({
        type: "double",
        min: 1,
        max: 5,
        step: 1,
        from: 1,
        to: 5,
        hide_min_max: true,
        hide_from_to: true,
        grid: true,
        onStart: function (data) {},
        onChange: function (data) {
          // vm.startTimer();
        },
        onFinish: function (data) {
          Vue.set(that.filterObject, "scoreLow", data.from);
          Vue.set(that.filterObject, "scoreHigh", data.to);
        },
        onUpdate: function (data) {
          // vm.startTimer();
        },
      });
    },
    updateReviewStatus: function (interview, status) {
      var that = this;
      var spinId = this.spinStart();
      apiClient
        .post("/api/org/review/status/", [
          {
            send: interview.id,
            status:
              status == 1
                ? "in-progress"
                : status == 2
                  ? "complete"
                  : "not-started",
          },
        ])
        .then(function () {
          that.spinStop(spinId);
        })
        .catch(function (error) {
          that.spinStop(spinId);
        });
    },
    // // LIST VIEW HELPERS ////
    exportAllCsv: function () {
      this.csvRequest({
        ivt: this.orgTypeFilter.type,
        t: this.orgSlateToken,
        c: this.filter_cycle,
        s: "all",
      });
    },
    csvDownload: function () {
      var that = this;
      var params = {
        ivt: this.orgTypeFilter.type,
        t: this.orgSlateToken,
        s: this.interviews
          .filter(function (iv) {
            return iv.checked;
          })
          .map(function (iv) {
            return iv.id;
          }),
      };
      if (params.s.length > 0) {
        that.csvRequest(params);
      }
    },
    csvRequest: function (params) {
      apiClient
        .post("/api/interview/admissions/getcsv/", params)
        .then(function (response) {
          if (response.status == 200) {
            var blob = new Blob([response.data], {
              type: "text/csv",
            });

            // Edge and IE
            if (navigator.msSaveBlob) {
              return navigator.msSaveBlob(blob, "InitialViewData.csv");
            }

            // everything else
            var url = window.URL.createObjectURL(blob);

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            a.href = url;
            a.download = "InitialViewData.csv";
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    },
    zipDownload: function (category) {
      var that = this;
      var params = {
        c: category,
        t: this.orgSlateToken,
        s: this.interviews
          .filter(function (iv) {
            return iv.checked;
          })
          .map(function (iv) {
            return iv.id;
          }),
      };
      if (params.s.length > 0) {
        apiClient
          .post("/api/interview/admissions/getzip/", params)
          .then(function (response) {
            if (response.data.status == 200) {
              var messageId = that.showMessage(
                "We're preparing your download and it will begin automatically in a few moments...",
                "alert-success",
              );
              var downloadToken = response.data.token;
              that.zipRequests[downloadToken] = {
                category: category,
                progress: 0,
                messageId: messageId,
              };

              // now we wait for the websocket to send us updates about response.data.token
              // and then call this.zipRetrieve(response.data.token) once it's ready!
              // for now, we poll

              var pollCount = 0;
              var poll = function () {
                apiClient
                  .get("/api/interview/admissions/poll_zip/?t=" + downloadToken)
                  .then(function (response) {
                    pollCount += 1;
                    if (response.data.status == 200) {
                      that.zipRetrieve(downloadToken);
                    } else {
                      if (pollCount > 10) {
                        that.hideMessage(
                          that.zipRequests[downloadToken].messageId,
                        );
                        that.showMessage(
                          "Sorry, something went wrong with your file download! Please try again or contact us if it's still not working.",
                          "alert-danger",
                        );
                        apiClient.post("/api/org/support/", {
                          message:
                            "AUTO ALERT: Zip download failed for token " +
                            downloadToken,
                        });
                      } else {
                        window.setTimeout(
                          poll,
                          1000 * Math.pow(pollCount, 1.5),
                        );
                      }
                    }
                  });
              };
              window.setTimeout(poll, 1000 + params.s.length * 100); // or 200, but we also don't want to wait too long for the firs tpoll!
            }
          });
      }
    },
    zipRetrieve: function (token) {
      //NOTE: I haven't yet gotten createObjectURL to work with a zip blob. Server is returning contents properly, so just use window.open() for now.
      this.hideMessage(this.zipRequests[token].messageId);
      window.open(
        "/api/interview/admissions/retrieve_zip/?t=" +
          token +
          "&c=" +
          this.zipRequests[token].category,
      );
    },

    // checkbox manager
    // Where checkbox is true, we will do the specified function to each interview.
    // actions: 'mark' (mark rows) 'export' (export rows)
    // options: 2 (complete)       1 (excel)
    //          1 (in progress)    2 (pdf)
    //          0 (not started)    3 (writing samples)
    whereCheckboxTrueAction: function (action, option) {
      var that = this;
      if (that.selectFewer) {
        that.hideMessage(that.selectFewer);
      }
      if (action == "mark") {
        var selecteds = [];
        that.interviews.forEach(function (iv) {
          if (iv.checked) {
            selecteds.push({
              send: iv.id,
              status:
                option == 1
                  ? "in-progress"
                  : option == 2
                    ? "complete"
                    : "not-started",
            });
            iv.reviewStatus = option; // TODO: do this on post success so UI reflects state of backend
          }
        });
        var spinId = that.spinStart();
        apiClient
          .post("/api/org/review/status/", selecteds)
          .then(function () {
            that.spinStop(spinId);
          })
          .catch(function (error) {
            that.spinStop(spinId);
          });
      }
      if (action == "export") {
        switch (option) {
          case 1: // excel
            console.log("starting excel export");
            that.csvDownload();
            break;
          case 2: // writing samples
            if (that.selectedInterviews > 100) {
              that.selectFewer = that.showMessage(
                "Please select a maximum of 100 interviews and try the operation again. If you need to export a large number of interviews, contact us and we will be happy to help you out!",
                "alert-danger",
              );
              return that.selectedInterviews;
            }
            console.log("starting writing sample export");
            that.zipDownload("writingsample");
            break;
          case 3: // pdf zip file.
            if (that.selectedInterviews > 100) {
              that.selectFewer = that.showMessage(
                "Please select a maximum of 100 interviews and try the operation again. If you need to export a large number of interviews, contact us and we will be happy to help you out!",
                "alert-danger",
              );
              return that.selectedInterviews;
            }
            console.log("starting pdf export");
            that.zipDownload("pdf");
            break;
        }
      }
      return that.selectedInterviews;
    },
    linkTo: function (link) {
      window.open(link);
    },
    invite_new_user: function () {
      var that = this;
      console.log(this.inviteUserEmail);
      var reqData = {
        email: this.inviteUserEmail,
      };

      apiClient
        .post("/api/user/amelia/invite/send/", reqData)
        .then(function (request) {
          if (request.status == 200) {
            that.showMessage(
              "Invite Sent!",
              "alert-success",
              that.uiMessageWaitLong,
            );
          } else {
            that.showMessage(
              "Invite Not Successful",
              "alert-danger",
              that.uiMessageWaitLong,
            );
          }
        });
    },
    update_password: function () {
      var that = this;
      if (this.newpass1 != this.newpass2) {
        this.showMessage(
          "Passwords Don't match",
          "alert-warning",
          this.uiMessageWaitLong,
        );
        return false;
      }
      if (this.newpass1.length < 8) {
        this.showMessage(
          "Password must be 8 characters or more",
          "alert-warning",
          this.uiMessageWaitLong,
        );
        return false;
      }
      var userInfo = {
        oldpass: this.oldpass,
        newpass: this.newpass1,
      };
      var spinId = this.spinStart();
      //change password (user is logged in already, no tempAccessCode needed.)
      apiClient
        .post(API_BASE + "/user/change_password/", userInfo)
        .then(function (request) {
          that.spinStop(spinId);
          if (request.data.status == 200) {
            that.showMessage(
              "Password Saved!",
              "alert-success",
              that.uiMessageWaitLong,
            );
            that.oldpass = "";
            that.newpass1 = "";
            that.newpass2 = "";
          } else {
            that.showMessage(
              "Transaction Error, try again",
              "alert-warning",
              that.uiMessageWaitLong,
            );
          }
        })
        .catch(function () {
          that.spinStop(spinId);
          that.showMessage(
            "Authorization Failed, try again?",
            "alert-danger",
            that.uiMessageWaitLong,
          );
        });
    },
    user_logout: function () {
      var that = this;
      var spinId = that.spinStart();
      apiClient
        .get("/api/user/sign_out/")
        .then(function (response) {
          that.spinStop(spinId);
          sessionStorage.removeItem("apitoken");
          // delete Vue.http.headers.common['Authorization'];
          delete apiClient.defaults.headers.common["Authorization"];
          ivbus.setFlag("user", null);
          that.fetchUser();
          window.location = that.serveraddr + "/login";
        })
        .catch(function () {
          that.spinStop(spinId);
          sessionStorage.removeItem("apitoken");
          // delete Vue.http.headers.common['Authorization'];
          delete apiClient.defaults.headers.common["Authorization"];
          ivbus.setFlag("user", null);
          window.location = that.serveraddr + "/login";
        });
    },
    RowClick: function (interviews, iv, index, event) {
      var that = this;
      if (!event.shiftKey) {
        this.toggleRow(iv, index);
      }
      if (event.shiftKey) {
        this.selectRowsBetweenIndexes(interviews, [
          that.lastSelectedRowIndex,
          index,
        ]);
      }
      // deselect text (ideally we would disable the selection functionality before it happens)
      if (window.getSelection) {
        if (window.getSelection().empty) {
          // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {
        // IE?
        document.selection.empty();
      }
    },

    toggleRow: function (iv, index) {
      iv.checked = !iv.checked;
      this.lastSelectedRow = iv;
      this.lastSelectedRowIndex = index;
    },
    selectRowsBetweenIndexes: function (interviews, indexes) {
      if (indexes[0] == indexes[1]) {
        return;
      }
      this.lastSelectedRow = interviews[indexes[1]];
      this.lastSelectedRowIndex = indexes[1];
      indexes.sort(function (a, b) {
        return a - b;
      });
      var allChecked = true;
      for (var i = indexes[0] + 1; i <= indexes[1]; i++) {
        if (!interviews[i].checked) {
          allChecked = false;
          break;
        }
      }
      for (var i = indexes[0]; i <= indexes[1]; i++) {
        interviews[i].checked = !allChecked;
      }
    },
    clearAll: function (interviews) {
      for (var i = 0; i < interviews.length; i++) {
        interviews[i].checked = false;
      }
      this.lastSelectedRow = null;
      this.lastSelectedRowIndex = null;
    },
    sendFeeWaiver: function (params) {
      var that = this;
      var spinId = that.spinStart();
      apiClient
        .post("/api/user/send_feewaiver_invite/", {
          couponCode: params.couponCode,
          inviteEmail: params.shareEmail.toEmail,
          inviteMessage: params.shareEmail.text,
        })
        .then(function (response) {
          that.spinStop(spinId);
          if (response.data.status == 200) {
            that.$set(that, "fee_waivers", response.data.fee_waivers);
          } else {
            that.showMessage(response.data.message, "alert-danger", 10000);
          }
        })
        .catch(function () {
          that.spinStop(spinId);
        });
    },

    requestMoreFeeWaivers: function () {
      var that = this;
      var spinId = that.spinStart();
      apiClient
        .post("/api/user/request_feewaivers/")
        .then(function (response) {
          that.spinStop(spinId);
          if (response.data.status == 200) {
            if (response.data.fee_waivers) {
              that.feewaiverRequestStatus = "granted";
              that.$set(that, "fee_waivers", response.data.fee_waivers);
            } else {
              that.feewaiverRequestStatus = "pending";
            }
          }
        })
        .catch(function () {
          that.spinStop(spinId);
        });
    },
  },
};
</script>

<style>
.orange-circle {
  border-radius: 50%;
  background-color: #eb8109;
  border: 1px solid #eb8109;
  width: 400px;
  height: 400px;
  opacity: 0.5;
  top: -83px;
  left: -100px;
  overflow: hidden;
  position: absolute;
}

.blue-circle {
  border-radius: 50%;
  background-color: #98cecd;
  border: 1px solid #98cecd;
  width: 400px;
  height: 400px;
  opacity: 0.5;
  bottom: -83px;
  right: -100px;
  overflow: hidden;
  position: absolute;
}

#icon-filter-grey {
  display: inherit;
  height: 16px;
  width: 16px;
  mask-image: url(/ivgcs/img/amelia-video-reply-sent.svg);
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background: #777;
}

#icon-filter-orange {
  display: inherit;
  height: 16px;
  width: 16px;
  mask-image: url(/ivgcs/img/amelia-video-reply-sent.svg);
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background: #e96724;
}

#icon-sent {
  display: inherit;
  height: 30px;
  width: 30px;
  margin: 5px;
  mask-image: url(/ivgcs/img/amelia-video-reply-sent.svg);
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background: #777;
}

#icon-seen {
  display: inherit;
  height: 30px;
  width: 30px;
  margin: 5px;
  mask-image: url(/ivgcs/img/amelia-video-reply-seen.svg);
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background: #e96724;
}

#icon-thanks {
  display: inherit;
  height: 30px;
  width: 30px;
  margin: 5px;
  mask-image: url(/ivgcs/img/amelia-video-reply-thanks.svg);
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background: #e96724;
}
</style>
